<template>
  <div v-if="vertrag" class="vertragsbanner">
    <template v-if="vertrag.product === 'Immobilie' && vertrag.wohnungen && vertrag.wohnungen[0]">
      <img v-if="hauptbild_url && hauptbild_url !== '' && hauptbild_url !== 'false'" class="logo-in-liste" :src="hauptbild_url"/>
      <br v-if="hauptbild_url && hauptbild_url !== '' && hauptbild_url !== 'false'" />
      <span class="vertrags-titeltext">
        <br/>
        <span class="erste_zeile"><b>{{vertrag.vertrag_mit_name}}</b></span><br/>
        <span class="zweite_zeile">Wohnung {{vertrag.wohnungen[0].nummer}}</span>
        <span class="zweite_zeile" v-if="vertrag.wohnungen[0].garage"> / Garage {{vertrag.wohnungen[0].garage}}</span>
        <span class="zweite_zeile" v-if="vertrag.wohnungen[0].tiefgarage"> / Tiefgarage {{vertrag.wohnungen[0].tiefgarage}}</span>
        <span class="zweite_zeile" v-if="vertrag.wohnungen[0].stellplatz"> / Stellplatz {{vertrag.wohnungen[0].stellplatz}}</span>
        <br/>
        <span class="zweite_zeile">{{vertrag.wohnungen[0].immobilie.bezeichnung}}</span>
      </span>
    </template>

    <template v-if="vertrag.product === 'Auvesta'">
      <img class="logo-in-liste" src="static/img/logo-auvesta.svg"/>
      <br/>
      <span class="vertrags-titeltext">
        <br/>
        <span class="erste_zeile"><b>Auvesta Gold-Depot: {{vertrag.auvesta_im_namen_von ? vertrag.auvesta_im_namen_von : vertrag.vertrag_mit_name}}</b></span>
        <br/>
        <span class="zweite_zeile">Zielsumme: {{format_euro(vertrag.summe)}}</span><br/>
        <span class="zweite_zeile">Depotnummer: {{vertrag.auvesta_depotnummer}}</span>
      </span>
    </template>

    <template v-if="vertrag.product === 'Opti5'">
      <img class="logo-in-liste" src="static/img/logo_opti_rente_adcuri-transparent.png"/>
      <br/>
      <span class="vertrags-titeltext">
        <br/>
        <span class="erste_zeile"><b>{{vertrag.vertrag_mit_name}}</b></span>
        <br/>
        <span class="zweite_zeile">Versicherungssumme: {{format_euro(vertrag.summe)}}</span><br/>
        <span class="zweite_zeile">Versicherungsnummer: {{vertrag.opti5_versicherungsnummer}}</span>
      </span>
    </template>
    <template v-if="vertrag.product === 'Multi Rente'">
      <img class="logo-in-liste" src="static/img/Janitos-Logo-rgb_gross.png"/>
      <br/>
      <span class="vertrags-titeltext">
        <br/>
        <span class="erste_zeile"><b>{{vertrag.vertrag_mit_name}}</b></span>
        <br/>
        <span class="zweite_zeile">Versicherungssumme: {{format_euro(vertrag.summe)}}</span><br/>
        <span class="zweite_zeile">Versicherungsnummer: {{vertrag.opti5_versicherungsnummer}}</span>
      </span>
    </template>

  </div>
</template>
<script>

export default {
  name: 'VetragBanner',
  props: ['vertrag', 'base_url'],
  data: function () {
    return {
    }
  },
  watch: {
  },
  components: {
  },
  computed: {
    hauptbild_url()
    {
      if( !this.vertrag || !this.get_hauptbild_url_fuer_vertrag(this.vertrag) || this.get_hauptbild_url_fuer_vertrag(this.vertrag) === '' || this.get_hauptbild_url_fuer_vertrag(this.vertrag) === 'false')
      {
        return ''
      }
      let url = ''
      if( !this.get_hauptbild_url_fuer_vertrag(this.vertrag).startsWith('https'))
      {
        url += this.base_url
      }
      url += this.get_hauptbild_url_fuer_vertrag(this.vertrag)
      return url
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>
